import { BaseMenu } from "./base-menu";

export class UserMenu extends BaseMenu {
    group: boolean = false;
    user: boolean = false;
}
